import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Divider, Grid, Paper, Tab, Tabs, TextField, Typography } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
import { ExpandMore } from '@mui/icons-material';
import Global from '../../../customlib/Global';
class ByReferralMobile extends Component {
    state = { } 

    render() { 
        return (
            <Box>
                <NavbarMobile title={"Inbound Referral Instagram"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props}>
                    </Filter>
                    {
                    this.props.contactLeads.map((lead, index) => {
                        return (
                            <Box elevation={2} sx={{mb: "10px", padding: "10px"}} key={`itemleads-${index}`}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <Typography component="span">{lead.fromName}</Typography>
                                    </Grid>
                                    <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                                        {Global.maskPhoneNumber(lead.from)}
                                    </Grid>
                                    <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                                        {Global.formatDateTimeToStrDateTime24(lead.created_at)}
                                    </Grid>
                                </Grid>
                                <Divider />
                            </Box>
                        );
                    })
                }
                </Box>
            </Box>
        );
    }
}
 
export default ByReferralMobile;